import React from "react"

class Addon extends React.Component {

  constructor(props) {
      super(props);
  }

  render () {
    return (
      <div className="w-30 pa4 br1 shadow-outer-1 mr4 mv4 tc">
        <a href={"https://elements.heroku.com/addons/" + this.props.addon.slug} target="_blank" className='no-underline dark-gray'>
          <img src={this.props.addon.icon_url} height={50} />
          <h4 className='dark-gray f4 bb pb2 b--silver'>{this.props.addon.name}</h4>
        </a>
        <p className='dark-gray mb1 f4'>{this.props.addon.summary}</p>
      </div>
    )
  }
}

Addon.defaultProps = {
  addon: {
    icon_url: '',
    name: '',
    summary: ''
  }
}

export default Addon
